import { ToastProvider } from "@/ds";

import { useFinanceiroObrasScreen } from "./use-financeiro-obras";
import { FinanceiroObrasScreenView } from "./view-financeiro-obras";

function FinanceiroObrasScreenLigada() {
  const vm = useFinanceiroObrasScreen();
  return <FinanceiroObrasScreenView {...vm} />;
}

/** Liga o ViewModel à View da tela Financeiro › Obras; o `ToastProvider` é o host único dos toasts da tela e dos diálogos de fichas. */
export function FinanceiroObrasScreen() {
  return (
    <ToastProvider position="top-right">
      <FinanceiroObrasScreenLigada />
    </ToastProvider>
  );
}

export type * from "./types-financeiro-obras";
